var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 10,
    viewBox: "0 0 391 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.927734,
    width: 391,
    height: 8.68889,
    rx: 4.34444,
    fill: "#50AF47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleLine);
export default __webpack_public_path__ + "static/media/rectangleLine.382234008ebf53ca7e2ee1f973ec1ac6.svg";
export { ForwardRef as ReactComponent };